import { cn } from './cn';

interface SpinnerProps {
  className?: string;
  label?: string;
}

export const Spinner = ({ className, label }: SpinnerProps) => (
  <svg
    aria-label={label}
    className={cn('inline-block text-accent animate-spin', className || 'w-5 h-5')}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

export const BlockingSpinner = ({ label = 'Please wait...' }: { label?: string }) => (
  <div className="fixed inset-0 z-[100] grid content-center justify-items-center bg-text bg-opacity-80">
      {/*<Spinner className="w-12 h-12" label={label} />*/}

      <svg viewBox="0 0 121 53" fill="none" xmlns="http://www.w3.org/2000/svg" className="suzy-loader w-60">
        <path className="suzy-letter" d="M0.668495 37.5227L0 26.949H1.78106C3.3377 29.9062 4.50757 31.9326 5.95438 33.9049C7.79036 36.3708 9.40429 36.9726 12.52 36.9726C16.8604 36.9726 18.9184 34.6171 18.9184 31.1662C18.9184 27.934 17.1946 26.0181 10.684 23.4981C2.67159 20.4868 0.279335 16.9818 0.279335 11.3941C0.279335 4.7109 5.78487 0 14.0742 0C18.8587 0 21.8073 0.547725 23.8653 1.31407L24.4216 10.6818H22.6978C21.251 7.8327 20.4178 6.51863 18.8038 4.65683C17.357 2.90318 16.3566 2.24732 13.3508 2.24732C9.51173 2.24732 7.45372 4.16553 7.45372 7.39546C7.45372 10.4091 8.51138 11.9959 14.9647 14.4077C23.531 17.6941 26.704 21.0369 26.704 26.5141C26.704 33.5264 21.4754 39.2763 12.0162 39.2763C6.84253 39.2763 2.89363 38.4536 0.666108 37.5227H0.668495Z" fill="#EE3341"/>
        <path className="suzy-letter" d="M31.4884 31.9891V16.3237C31.4884 14.0223 31.3761 13.8037 29.7646 12.8728L27.8164 11.7773V10.6278L39.7228 9.42188L40.3913 9.91553V29.8546C40.3913 33.0869 41.671 34.3469 44.1754 34.3469C46.1785 34.3469 48.0694 33.6887 49.404 33.2514V16.326C49.404 14.0246 49.2369 13.752 47.623 12.8751L45.7321 11.7797V10.6302L57.5811 9.42423L58.2496 9.91788V32.0478C58.2496 34.7324 58.4168 35.0615 60.0856 35.7174L61.6996 36.3756V37.6896L50.1847 39.2787L49.5735 38.8415L49.6857 35.172H49.4064C46.4579 37.3088 43.0653 39.2811 38.7797 39.2811C34.4942 39.2811 31.4931 36.8152 31.4931 31.9961L31.4884 31.9891Z" fill="#EE3341"/>
        <path className="suzy-letter" d="M62.8652 36.2626L78.7205 12.7081V12.4895H76.0513C71.9902 12.4895 71.0448 12.7081 69.7101 14.1326C68.2633 15.6653 67.4301 17.1463 65.8162 19.8849H64.3144L64.9256 10.1904H88.5689V12.3813L72.7685 36.1004V36.319H75.495C80.6138 36.319 81.7263 35.9358 83.1159 34.2386C84.4505 32.5954 85.6752 30.7877 86.9 28.5427H88.4567L87.5661 38.6227H62.8652V36.2673V36.2626Z" fill="#EE3341"/>
        <path className="suzy-letter" d="M90.7363 45.9571C90.7363 43.9308 92.1282 42.7249 94.2411 42.7249C96.4662 42.7249 97.4117 43.5476 97.968 45.5176C98.19 46.3403 98.4693 46.613 99.0256 46.613C100.193 46.613 101.418 45.2989 103.366 40.9171L103.977 39.4926L93.6299 16.3212C92.016 12.7599 91.6817 12.3226 90.4593 11.9395L89.459 11.6103V10.1858H105.871V11.6103L104.369 11.9935C103.256 12.3226 102.645 12.8703 102.645 14.1303C102.645 14.9531 102.924 15.9921 103.423 17.1981L108.318 29.4126H108.54L113.212 17.1981C113.713 15.884 113.99 14.7886 113.99 13.9117C113.99 12.8163 113.379 12.3226 112.209 11.9935L110.653 11.6103V10.1858H121V11.6103L119.72 12.0476C118.328 12.4848 117.997 13.2535 116.495 16.869L106.147 41.4084C103.922 46.5566 101.864 50.0075 96.4686 50.0075C93.1309 50.0075 90.7387 48.3643 90.7387 45.9548L90.7363 45.9571Z" fill="#EE3341"/>
      </svg>


      <p className="text-sm text-white">{label}</p>
  </div>
);
